/**
 * Skeleton — a shimmering placeholder block for loading states in the Marketer
 * View. Reuses the global `shimmer` keyframe (App.css) so the loading phase
 * reads as obviously loading rather than as finished, low-confidence content.
 */

import React from 'react';

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  radius?: number;
  style?: React.CSSProperties;
}

export const Skeleton: React.FunctionComponent<SkeletonProps> = ({
  width = '100%',
  height = 14,
  radius = 7,
  style,
}) => (
  <span
    aria-hidden
    style={{
      display: 'block',
      width,
      height,
      borderRadius: radius,
      background:
        'linear-gradient(90deg, #eef2f7 0%, #e2e8f0 50%, #eef2f7 100%)',
      backgroundSize: '200% 100%',
      animation: 'shimmer 1.4s linear infinite',
      ...style,
    }}
  />
);

/** A stack of skeleton lines (last one shorter), for multi-line text blocks. */
export const SkeletonLines: React.FunctionComponent<{
  lines?: number;
  height?: number;
  gap?: number;
  lastWidth?: string;
  style?: React.CSSProperties;
}> = ({ lines = 3, height = 12, gap = 8, lastWidth = '70%', style }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap, ...style }}>
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton
        key={i}
        height={height}
        width={i === lines - 1 ? lastWidth : '100%'}
      />
    ))}
  </div>
);
